import React from "react";

import { Box } from "@mui/material";
import { DatePicker } from "@mui/x-date-pickers";
import { useAccelContext } from "../../contexts/AccelContext/AccelContext";
import { AccelContextActionName } from "../../types/AccelContext";
import dayjs from "dayjs";
import { SxProps, Theme } from "@mui/material";

interface AccelDatePickerProps {
  boxSx?: SxProps<Theme>;
}

const AccelDatePicker: React.FC<AccelDatePickerProps> = ({ boxSx }) => {
  const { theme, selectedDate, dispatcher } = useAccelContext();

  const handleDateChange = (date: dayjs.Dayjs | null) => {
    
    dispatcher({
      type: AccelContextActionName.setSelectedDate,
      payload: { selectedDate: date ?? dayjs() },
    });
  };

  return (
    <Box sx={{ display: "inline-block", ...boxSx }}>
      <DatePicker
        value={selectedDate}
        onChange={handleDateChange}
        views={["month", "year"]}
        format="MMM YYYY"
        sx={{
          "& .MuiInputBase-root": {
            height: "36px",
            color: theme?.secondary?.hex || "#000000",
            textColor: theme?.text?.hex || "#000000",
            borderColor: theme?.secondary?.hex || "#000000",
            "& fieldset": {
              borderColor: theme?.secondary?.hex || "#000000",
            },
            "&:hover fieldset": {
              borderColor: theme?.secondary?.hex || "#000000",
            },
            "&.Mui-focused fieldset": {
              borderColor: theme?.secondary?.hex || "#000000",
            },
          },
          "& .MuiInputBase-input": {
            color: theme?.secondary?.hex || "#000000",
            padding: "7px 0 7px 8px", // Remove right padding
            width: "80px", // Set a fixed width for the input
          },
          "& .MuiSvgIcon-root": {
            color: theme?.secondary?.hex || "#000000",
            textColor: theme?.text?.hex || "#000000",
          },
          "& .MuiIconButton-root": {
            padding: "4px",
            marginLeft: "-24px", // Move the icon to the left
          },
        }}
      />
    </Box>
  );
};

export default AccelDatePicker;
